import { render, staticRenderFns } from "./MessageComposer.vue?vue&type=template&id=56da1951&scoped=true"
import script from "./MessageComposer.vue?vue&type=script&lang=js"
export * from "./MessageComposer.vue?vue&type=script&lang=js"
import style0 from "./MessageComposer.vue?vue&type=style&index=0&id=56da1951&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56da1951",
  null
  
)

export default component.exports